export const PAGES_LIST_KEY = 'PAGES_LIST';
export const PAGES_ONE_KEY = 'PAGES_ONE_KEY';
